import React, { useState } from 'react';
import '../styles/how.scss';

import CONTENT from '../constants/content';
import Emulator from '../assets/how.gif';

function How() {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="How">
      <div className="container container-how">
        <div>
          <img className="how-emulator" alt="Emulator" src={Emulator}></img>
        </div>

        <div className="content-container-how">
          <p className="titleHow">How it works?</p>
          <p className="subtitleHow">Quests, step by step.</p>
          <p className="textHow">
            {expanded ? CONTENT.howMore : CONTENT.how}
          </p>
          <p onClick={() => setExpanded(!expanded)} className="readMoreHow">
            {expanded ? "Read less <" : "Read more >"}
          </p>
        </div>
      </div>
    </div>
  );
}

export default How;
